var map = {
	"./CircleShape/Component": [
		5887,
		887
	],
	"./Group/Component": [
		5734,
		734
	],
	"./LineShape/Component": [
		7776,
		776
	],
	"./Picture/Component": [
		3652,
		652
	],
	"./RectShape/Component": [
		1528,
		528
	],
	"./VButton/Component": [
		9614,
		614
	],
	"./VChart/Component": [
		5603,
		603
	],
	"./VInputCode/Component": [
		8273,
		273
	],
	"./VInsertImg/Component": [
		8064,
		64
	],
	"./VResult/Component": [
		6679,
		679
	],
	"./VSwiper/Component": [
		4364,
		364
	],
	"./VTable/Component": [
		1752,
		752
	],
	"./VText/Component": [
		3308,
		308
	],
	"./svgs/SVGStar/Component": [
		9733,
		733
	],
	"./svgs/SVGTriangle/Component": [
		1673,
		673
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 3884;
module.exports = webpackAsyncContext;